import Service from '@/helpers/service'

export default {

    index(params) {
        return Service().get('equipment/index', {params});
    },
    getEquipment(params) {
        return Service().get('equipment/get-equipment', {params});
    },
    show(id) {
        return Service().get('equipment/show/'+id);
    },
    create(params) {
        return Service().post('equipment/create', params, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
        });
    },
    update(id, params) {
        return Service().post('equipment/update/'+id, params, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
        });
    },
    delete(id) {
        return Service().post('equipment/delete/'+id);
    },
}